import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockClaims } from '@percent/admin-dashboard/fixtures/api/mockClaims'

export const claimsHandlers = [
  rest.get(`${config.urls.api}v1/admin/claims`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json(mockClaims))
  })
]
